import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "../components/dashboard/adminsidebar";
import AdminDashnavbar from "../components/dashboard/admindashnavbar";

const AdminDashboard = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <>
      <div className="flex overflow-x-hidden relative min-h-screen bg-dashbg ">
        <div className="max-md:p-[0px]">
          <AdminSidebar isDrawerOpen={isDrawerOpen} toggleDrawer={toggleDrawer} />
        </div>

        <div className=" p-[18px] ml-auto max-w-full w-[calc(100vw-270px)] max-md:w-full max-md:ml-0 max-sm:px-[20px] max-sm:py-[10px]">
          <AdminDashnavbar toggleDrawer={toggleDrawer} />
          <div className="page-dom">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
